// eslint globals
/* global AOS */
document.addEventListener('DOMContentLoaded', function () {


  // countdown
  function CountDownTimer(dt, id) {
    let
      end = new Date(dt),
      _second = 1000,
      _minute = _second * 60,
      _hour = _minute * 60,
      _day = _hour * 24,
      timer;

    function showRemaining() {
      let
        now = new Date(),
        distance = end.getTime() - now.getTime(),
        days = Math.floor(distance / _day),
        hours = Math.floor((distance % _day) / _hour),
        minutes = Math.floor((distance % _hour) / _minute),
        seconds = Math.floor((distance % _minute) / _second);

      if (distance < 0) {
        clearInterval(timer);
        document.getElementById(id).innerHTML = 'Pasibaigė!';
        return;
      }

      document.getElementById(id).innerHTML = '<div class="hero-timer__countdown__col">' + days + '<span class="hero-timer__countdown__txt">Dienos</span></div>';
      document.getElementById(id).innerHTML += '<div class="hero-timer__countdown__col">' + hours + '<span class="hero-timer__countdown__txt">Valandos</span></div>';
      document.getElementById(id).innerHTML += '<div class="hero-timer__countdown__col">' + minutes + '<span class="hero-timer__countdown__txt">Minutės</span></div>';
      document.getElementById(id).innerHTML += '<div class="hero-timer__countdown__col">' + seconds + '<span class="hero-timer__countdown__txt">Sekundės</span></div>';
    }

    showRemaining();
    timer = setInterval(showRemaining, 1000);
  }

  if (document.getElementById('countdown')) {
    CountDownTimer('12/13/2023 10:00 AM', 'countdown');
  }


  // animation
  AOS.init({
    once: true
  });


}, false);
